// extracted by mini-css-extract-plugin
export default {"wrapper":"SellingPlanGroupList_wrapper__L5q6Z"};